import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./collections.${locale}.json`));
